(function () {
  if (window.__treePickupAckInit) return;
  window.__treePickupAckInit = true;

  var CHECKOUT_BTNS = 'button[name="checkout"], button.cart__checkout';
  var TREE_HANDLE_FRAGMENT = 'ulu-tree';

  var hasTree = false;
  var acknowledged = false;

  function wraps() { return document.querySelectorAll('[data-tree-pickup-ack]'); }

  function sync() {
    var blocked = hasTree && !acknowledged;
    wraps().forEach(function (w) {
      w.hidden = !hasTree;
      var box = w.querySelector('input[type="checkbox"]');
      if (box) box.checked = acknowledged;
    });
    document.querySelectorAll(CHECKOUT_BTNS).forEach(function (btn) {
      btn.toggleAttribute('disabled', blocked);
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    });
    document.querySelectorAll('.cart__buttons .dynamic-button, .cart__buttons .additional-checkout-buttons').forEach(function (el) {
      el.style.display = blocked ? 'none' : '';
    });
  }

  function refreshTreeState() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        hasTree = (c.items || []).some(function (it) {
          return typeof it.handle === 'string' && it.handle.indexOf(TREE_HANDLE_FRAGMENT) !== -1;
        });
        acknowledged = hasTree && !!c.attributes && c.attributes['Tree pickup acknowledged'] === 'Yes';
        sync();
      })
      .catch(function () {});
  }

  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshTreeState, 350);
  }

  // Checkbox toggles → persist as a cart attribute (lands on the order) + re-sync
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('[data-tree-pickup-ack]')) return;
    acknowledged = e.target.checked;
    var wrap = e.target.closest('[data-tree-pickup-ack]');
    wrap.classList.remove('tree-pickup-ack--error');
    var err = wrap.querySelector('.tree-pickup-ack__error');
    if (err) err.hidden = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Tree pickup acknowledged': acknowledged ? 'Yes' : '' } })
    }).catch(function () {});
    sync();
  });

  // Capture-phase guard: catches the button even if a re-render dropped the disabled attr
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(CHECKOUT_BTNS);
    if (!btn) return;
    if (hasTree && !acknowledged) {
      e.preventDefault();
      e.stopPropagation();
      wraps().forEach(function (w) {
        if (w.hidden || !w.offsetParent) return;
        w.classList.add('tree-pickup-ack--error');
        var err = w.querySelector('.tree-pickup-ack__error');
        if (err) err.hidden = false;
        var box = w.querySelector('input[type="checkbox"]');
        if (box) box.focus();
      });
    }
  }, true);

  new MutationObserver(scheduleRefresh).observe(document.body, { childList: true, subtree: true });
  refreshTreeState();
})();